module.exports = global["jQuery"] = require("-!/Users/uzhu/Desktop/lb/修改备案/uzhu-pms-web/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./~/expose-loader?$!./~/jquery/dist/jquery.js-exposed
// module id = 159
// module chunks = 64